import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

// Local type definition (ai-apps removed)
export type DashboardPageType = {
  id: string;
  name: string;
  page_group_id: string;
  layout: string;
  status: string;
  description: string;
  created_at: string;
  updated_at: string;
  group_name?: string;
  css?: string;
  script?: string;
};

export const initialState: DashboardPageType = {
  id: "",
  name: "",
  page_group_id: "",
  layout: "",
  status: "",
  description: "",
  created_at: "",
  updated_at: ""
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    //push value dashboard. use when user showing modal detail dashboard and move editor result dashboard
    pushValueDashboard: (_state, action: PayloadAction<DashboardPageType>) => {
      return (_state = action.payload);
    }
  }
});

export const { pushValueDashboard } = dashboardSlice.actions;
export default dashboardSlice.reducer;
